import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function CRMPlatforms() {
  return <ServiceDetailPage service={servicePageContent.crmPlatforms} />;
}
